import { Fragment } from 'react';
import home from '~/assets/icons/home.svg';
import plateNumber from '~/assets/icons/plateNumber.svg';
import { CollectionImage } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import {
	IExchangeItem,
	IExchangeItemHouse,
	IExchangeItemMoney,
	IExchangeItemNumberPlate,
	IExchangeItemVehicle,
} from '~/rage';
import { ExchangeItemType } from '~/shared';
import soft from '../../assets/images/soft.png';
import { formatNumberPlate } from './FinishScreenItem.model';
import { StyledContainer } from './FinishScreenItem.styled';

const FinishScreenItem = ({ item }: { item: IExchangeItem }) => {
	return (
		<StyledContainer>
			{item.type === ExchangeItemType.House && (
				<Fragment>
					<img src={home} width={50} height={50} />
					<Text>Дом #{(item as IExchangeItemHouse)?.houseId}</Text>
				</Fragment>
			)}
			{item.type === ExchangeItemType.Money && (
				<Fragment>
					<img src={soft} width={61} height={50} />
					<Text>
						{(item as IExchangeItemMoney)?.amount?.toLocaleString('ru-RU')}
					</Text>
				</Fragment>
			)}
			{item.type === ExchangeItemType.Vehicle && (
				<CollectionImage
					collection={'vehicles'}
					id={(item as IExchangeItemVehicle).vehicleId}
					size={'sm'}
				/>
			)}
			{item.type === ExchangeItemType.NumberPlate && (
				<Fragment>
					<img src={plateNumber} width={50} height={50} />
					<Text>
						{formatNumberPlate((item as IExchangeItemNumberPlate)?.numberPlate)}
					</Text>
				</Fragment>
			)}
		</StyledContainer>
	);
};

export { FinishScreenItem };
